import { TORTUOSITY_FACTOR } from '../math/geo';

// --- CENTRALIZED LOGISTICS CONSTANTS ---
// SINGLE SOURCE OF TRUTH for all static logistic parameters.

// 1. Navigation & Speed
export { TORTUOSITY_FACTOR };
export const COLD_START_MINS_PER_KM = 2.8; // Fallback speed (approx 21.4 km/h)
export const MIN_LEARNED_SPEED_KMH = 10;   // Noise floor
export const MAX_LEARNED_SPEED_KMH = 60;   // Safety ceiling
export const AVERAGE_MINUTES_PER_KM = COLD_START_MINS_PER_KM; // Legacy alias

// 2. Safe Departure (Timing) Defaults
export const DEFAULT_SERVICE_TIME_OWN = 3;   // Minutes at door (Internal)
export const DEFAULT_SERVICE_TIME_THIRD = 4; // Minutes at door (External)
export const DEFAULT_SLA_TOLERANCE_OWN = 10; // "Buffer" (Internal)
export const DEFAULT_SLA_TOLERANCE_THIRD = 5;// "Buffer" (External)

// 3. Helpers
export const speedKmhToMinPerKm = (kmh: number) => 60 / kmh;
export const minPerKmToSpeedKmh = (mpk: number) => 60 / mpk;

// 4. Metric Keys
export const METRIC_KEY_ESTIMATE_USAGE = 'LOGISTICS_ESTIMATE_USAGE_V1';

// 5. Routing API health + cache freshness
export const ROUTING_GLOBAL_CACHE_MAX_AGE_MS = 15 * 60 * 1000;
export const ROUTING_STORE_CACHE_MAX_AGE_MS = 20 * 60 * 1000;
export const ROUTING_PROVIDER_HEALTH_CACHE_KEY = 'routing_provider_health_v1';
export const ROUTING_PROVIDER_HEALTH_HISTORY_LIMIT = 20;

export const getEffectivedSpeedMinPerKm = (driverSpeedKmh?: number): number => {
    if (driverSpeedKmh && driverSpeedKmh >= MIN_LEARNED_SPEED_KMH && driverSpeedKmh <= MAX_LEARNED_SPEED_KMH) {
        return speedKmhToMinPerKm(driverSpeedKmh);
    }
    return COLD_START_MINS_PER_KM;
};
